import Reflux from 'reflux';

const ServerAvailabilityActions = Reflux.createActions([
  'reportError',
  'reportSuccess',
]);

export default ServerAvailabilityActions;



// WEBPACK FOOTER //
// ./src/actions/sessions/ServerAvailabilityActions.jsx